
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Premiumcabserviceinpune() {



    const cardData =
    {
        keyword: 'Premium Cab Service in Pune',
        heading: 'Platinum24 Cabs: Premium Cab Service in Pune',
        headingDescription: ' Platinum24 Cabs delivers exceptional Premium Cab Service in Pune, designed for travelers who value comfort, luxury, and professionalism. Our fleet includes high-end sedans, SUVs, and luxury cars with plush interiors, modern features, and top-class safety standards. Perfect for corporate executives, weddings, VIP travel, and special occasions, our premium cabs ensure a stylish and hassle-free journey. With professional chauffeurs, punctual pickups, and 24/7 availability, Platinum24 Cabs guarantees a superior travel experience, combining luxury and reliability to make every ride in Pune truly memorable.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Kaas Plateau (Valley of Flowers)",
    "description": "Kaas Plateau, a UNESCO World Natural Heritage Site near Satara, is famous for its seasonal bloom of wildflowers. From August to October, the plateau turns into a colorful carpet of orchids, lilies, and rare species. Nature lovers and photographers flock here for its breathtaking landscapes. The site is carefully protected, ensuring eco-friendly tourism. Misty monsoons make it even more enchanting. Kaas Plateau is Satara’s crown jewel of natural beauty."
  },
  {
    "title": "Ajinkyatara Fort",
    "description": "Ajinkyatara Fort, perched at 3,300 feet, offers panoramic views of Satara city. Built in the 16th century, it played a strategic role in Maratha history. The fort has bastions, gates, and temples like Hanuman and Devi shrines. Trekking up is moderately easy and rewarding with scenic vistas. It is especially popular during monsoon. Ajinkyatara Fort is Satara’s living reminder of Maratha valor."
  },
  {
    "title": "Thoseghar Waterfall",
    "description": "Thoseghar Waterfall near Satara is a breathtaking cascade that plunges from over 1,000 feet. Surrounded by lush green hills, it is one of Maharashtra’s tallest waterfalls. Monsoon transforms it into a thundering natural wonder. Visitors enjoy viewpoints and picnic spots nearby. Photographers capture its majestic flow and misty ambiance. Thoseghar is Satara’s monsoon paradise."
  },
  {
    "title": "Sajjangad Fort",
    "description": "Sajjangad Fort is a revered spiritual site, known as the final resting place of Sant Ramdas, spiritual guide of Chhatrapati Shivaji Maharaj. Pilgrims visit for its temples and ashrams, where bhajans and prayers create a divine aura. The fort also offers scenic views of valleys and lakes. Devotees believe visiting here grants peace and blessings. Sajjangad is Satara’s sacred blend of history and spirituality."
  },
  {
    "title": "Koyna Dam & Wildlife Sanctuary",
    "description": "Koyna Dam, built on the Koyna River, is one of India’s largest hydroelectric projects. Surrounded by the Western Ghats, it creates the beautiful Shivsagar Lake. The nearby Koyna Wildlife Sanctuary is home to tigers, leopards, and diverse flora and fauna. Monsoon enhances the greenery and water levels, making it a scenic retreat. Boating and nature walks are popular here. Koyna is Satara’s powerhouse of beauty and energy."
  },
  {
    "title": "Natraj Mandir, Satara",
    "description": "Natraj Mandir in Satara is a unique temple dedicated to Lord Shiva in the form of Nataraja, inspired by the famous Chidambaram temple of Tamil Nadu. Its Dravidian-style architecture and intricate carvings attract devotees and tourists. The temple is serene and spiritually uplifting. Festivals like Mahashivratri draw large crowds. Surrounded by peaceful ambiance, it is ideal for meditation. Natraj Mandir is Satara’s sacred cultural landmark."
  },
  {
    "title": "Kaas Lake",
    "description": "Kaas Lake, located near the famous Kaas Plateau, is a tranquil water body surrounded by greenery. It was originally built as a reservoir for Satara. The calm environment makes it ideal for relaxation and photography. Migratory birds can be spotted during certain seasons. Tourists often combine a visit with the flower valley. Kaas Lake is Satara’s peaceful natural retreat."
  },
  {
    "title": "Chalkewadi Windmill Farms",
    "description": "Chalkewadi Windmill Farms, near Thoseghar, feature hundreds of giant windmills dotting the hills. It is one of Maharashtra’s largest wind energy projects. The landscape looks surreal, especially during monsoon with mist and waterfalls around. Tourists enjoy scenic drives and photography here. The site is peaceful yet futuristic in appeal. Chalkewadi is Satara’s blend of green energy and natural charm."
  },
  {
    "title": "Jarandeshwar Temple & Caves",
    "description": "Jarandeshwar Temple near Satara is dedicated to Lord Shiva and is located near ancient Buddhist caves. The caves have rock-cut architecture and historical significance. Pilgrims visit the temple for its divine aura and natural setting. The site is surrounded by forests and hills, making it serene. It attracts both history lovers and devotees. Jarandeshwar is Satara’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Yamai Devi Temple, Aundh",
    "description": "Located near Satara, the Yamai Devi Temple at Aundh is an ancient and highly revered shrine. Dedicated to Goddess Yamai, it is an important pilgrimage site in Maharashtra. Devotees climb steps to reach the temple perched on a hilltop. The temple is especially vibrant during Navratri. It also offers panoramic views of the surrounding landscape. Yamai Devi Temple is Satara’s divine abode of faith and devotion."
  }
],



   "services": [
    {
      "name": "Premium Cab Pune",
      "description": "Experience the highest standard of travel with Premium Cab Pune, where luxury meets comfort and professionalism. Our premium fleet consists of well-maintained vehicles offering plush interiors, cutting-edge amenities, and skilled chauffeurs. Whether it’s for business, special occasions, or leisurely travel, enjoy a first-class ride that reflects your style and sophistication."
    },
    {
      "name": "Pune Premium Taxi Service",
      "description": "Pune Premium Taxi Service provides exclusive transportation solutions tailored for discerning clients who value comfort, punctuality, and premium service quality. With our dedicated support and attention to detail, each ride is curated to ensure a smooth, safe, and luxurious journey throughout Pune and beyond."
    },
    {
      "name": "Luxury Premium Cab Pune",
      "description": "Travel in style with Luxury Premium Cab Pune, featuring top-of-the-line vehicles such as luxury sedans and SUVs equipped with modern conveniences. Perfect for airport transfers, corporate travel, and special events, our luxury cabs offer privacy, elegance, and exceptional customer service for an unforgettable ride experience."
    },
    {
      "name": "Premium Taxi Booking Pune",
      "description": "Book your Premium Taxi in Pune effortlessly through our user-friendly online platform or customer support. Enjoy transparent pricing, real-time tracking, and guaranteed availability of premium vehicles that ensure your travel is not only comfortable but also hassle-free and timely."
    },
    {
      "name": "Pune Premium Cab with Driver",
      "description": "Our Pune Premium Cab with Driver service pairs you with professional chauffeurs trained to provide courteous, safe, and punctual service. Whether navigating city traffic or long-distance travel, the driver’s expertise combined with premium car comfort makes every journey relaxing and efficient."
    },
    {
      "name": "Premium Car Rental Pune",
      "description": "Rent premium cars in Pune for short-term or long-term use with our reliable Premium Car Rental service. Select from a wide range of luxury models tailored for corporate clients, weddings, and exclusive personal travel, backed by comprehensive insurance and maintenance support."
    },
    {
      "name": "Premium Cab Service Deals Pune",
      "description": "Take advantage of exclusive Premium Cab Service Deals in Pune, including discounted rates, seasonal offers, and package deals for corporate bookings and frequent travelers. These deals ensure you receive luxury service at competitive prices without compromising on quality or comfort."
    },
    {
      "name": "Pune Premium Taxi Packages",
      "description": "Explore our tailored Pune Premium Taxi Packages designed for various travel needs, such as hourly rentals, outstation tours, airport transfers, and event-specific transport. Each package is designed to offer flexibility, convenience, and premium service at attractive pricing."
    },
    {
      "name": "Premium Airport Taxi Pune",
      "description": "Arrive and depart with ease using our Premium Airport Taxi Pune service. We provide timely pickups and drop-offs with professional drivers who track flight schedules to ensure punctuality. Enjoy spacious vehicles equipped for your luggage and a smooth, stress-free airport transfer experience."
    },
    {
      "name": "Pune Premium Outstation Taxi",
      "description": "For long-distance travel, Pune Premium Outstation Taxi offers luxurious rides that blend comfort with reliability. Whether it’s a business trip or a leisure journey outside Pune, our premium taxis guarantee a first-class experience with well-maintained vehicles and experienced drivers."
    },
    {
      "name": "Pune Premium City Taxi",
      "description": "Navigate Pune’s busy streets in style and comfort with Pune Premium City Taxi. Ideal for business meetings, shopping trips, or special outings, our premium city taxis ensure you arrive on time in a sophisticated vehicle that meets your high expectations."
    },
    {
      "name": "Affordable Premium Taxi Pune",
      "description": "Get the best of luxury without breaking the bank with our Affordable Premium Taxi Pune service. We balance premium quality and affordability to provide accessible luxury travel options for a wide range of clients looking for value and excellence."
    },
    {
      "name": "Pune Premium Cab Service Near Me",
      "description": "Find the closest Premium Cab Service Near Me in Pune easily with our extensive network of premium vehicles stationed across the city. No matter your location, access top-tier cabs quickly for immediate or scheduled rides with guaranteed luxury and professionalism."
    },
    {
      "name": "Pune Premium Cab for Corporate",
      "description": "Our Pune Premium Cab for Corporate clients offers tailored transport solutions for executives, business events, and employee commute services. Benefit from punctual pickups, privacy, premium vehicle comfort, and dedicated support designed to meet the high standards of corporate travel."
    },
    {
      "name": "Pune Premium Taxi Service Online",
      "description": "Book your premium taxi online in Pune with our streamlined Pune Premium Taxi Service Online platform. Enjoy convenience with instant booking confirmations, transparent fare estimates, and the ability to manage your rides anytime and anywhere from your smartphone or computer."
    }
  ],
  "tableData": [
    ["Premium Cab Pune", "Pune Premium Taxi Service"],
    ["Luxury Premium Cab Pune", "Premium Taxi Booking Pune"],
    ["Pune Premium Cab with Driver", "Premium Car Rental Pune"],
    ["Premium Cab Service Deals Pune", "Pune Premium Taxi Packages"],
    ["Premium Airport Taxi Pune", "Pune Premium Outstation Taxi"],
    ["Pune Premium City Taxi", "Affordable Premium Taxi Pune"],
    ["Pune Premium Cab Service Near Me", "Pune Premium Cab for Corporate"],
    ["Pune Premium Taxi Service Online", "—"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Luxurious Premium Cab Service in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers top-notch premium cab services with luxury vehicles for a comfortable and stylish ride."
    },
    {
      "WhyChooseheading": "High-End Vehicles for Ultimate Comfort",
      "WhyChoosedescription": "Choose from premium sedans and SUVs that are well-maintained and equipped with modern amenities."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs for a Smooth Experience",
      "WhyChoosedescription": "Our experienced and courteous drivers ensure a safe, timely, and pleasant journey."
    },
    {
      "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
      "WhyChoosedescription": "Travel worry-free with our regularly sanitized luxury vehicles."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Customize your travel plans with flexible packages designed to meet your premium service needs."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for hassle-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings and special requests."
    },
    {
      "WhyChooseheading": "Ideal for Corporate Travel, Special Occasions, and Luxury Tours",
      "WhyChoosedescription": "Perfect for business trips, weddings, and other premium travel needs in Pune."
    }
  ]





































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer premium cab services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides premium cab services in Pune featuring luxury and high-end vehicles for a comfortable and stylish ride.',
    },
    {
        question: 'How can I book a premium cab in Pune with Platinum24 Cabs?',
        answer: 'You can book your premium cab easily via our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of premium vehicles are available in Pune?',
        answer: 'We offer luxury sedans, SUVs, and executive cars from top brands to cater to your premium travel needs.',
    },
    {
        question: 'Are the premium cab drivers experienced and professional?',
        answer: 'Yes, our premium cab drivers are highly trained, professional, and committed to providing a superior travel experience.',
    },
    {
        question: 'Can I book premium cabs for airport transfers and corporate events?',
        answer: 'Absolutely! Our premium cab services are ideal for airport pickups, corporate travel, and special occasions.',
    },
    {
        question: 'Are premium cabs available for hourly and outstation bookings?',
        answer: 'Yes, you can book premium cabs for hourly rentals, local trips, or outstation journeys from Pune.',
    },
    {
        question: 'What safety and hygiene measures are followed in premium cabs?',
        answer: 'All premium vehicles are regularly sanitized, and drivers adhere to strict safety protocols for your protection.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for premium cab rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere within Pune or beyond.',
    },
    {
        question: 'Are there flexible payment options for premium cab services?',
        answer: 'Yes, we accept multiple payment methods including credit/debit cards, digital wallets, and corporate billing options.',
    },
    {
        question: 'Does Platinum24 Cabs provide 24x7 premium cab service in Pune?',
        answer: 'Yes, our premium cab services are available 24x7 to meet your travel needs anytime.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Siddharth Malhotra',
        feedback: 'The premium cab service by Platinum24 Cabs was exceptional. The vehicle was luxurious and the driver was professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Nisha Kapoor',
        feedback: 'I booked a premium cab for my corporate event and was very impressed with the service and comfort provided.',
        rating: 5,
    },
];




















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const premiumCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Premium cab service in Pune offering luxury and affordable premium taxi options with professional drivers, available for airport transfers, corporate trips, and outstation travel.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "Premium Cab Pune",
    "Pune Premium Taxi Service",
    "Luxury Premium Cab Pune",
    "Premium Taxi Booking Pune",
    "Pune Premium Cab with Driver",
    "Premium Car Rental Pune",
    "Premium Cab Service Deals Pune",
    "Pune Premium Taxi Packages",
    "Premium Airport Taxi Pune",
    "Pune Premium Outstation Taxi",
    "Pune Premium City Taxi",
    "Affordable Premium Taxi Pune",
    "Pune Premium Cab Service Near Me",
    "Pune Premium Cab for Corporate",
    "Pune Premium Taxi Service Online"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>

<Helmet>
  <title>Premium Cab Service in Pune | Luxury & Affordable Taxi</title>
  <meta
    name="description"
    content="Premium cab service in Pune offering luxury and affordable premium taxi options with professional drivers, available for airport transfers, corporate trips, and outstation travel."
  />
  <meta
    name="keywords"
    content="Premium Cab Pune, Pune Premium Taxi Service, Luxury Premium Cab Pune, Premium Taxi Booking Pune, Pune Premium Cab with Driver, Premium Car Rental Pune, Premium Cab Service Deals Pune, Pune Premium Taxi Packages, Premium Airport Taxi Pune, Pune Premium Outstation Taxi, Pune Premium City Taxi, Affordable Premium Taxi Pune, Pune Premium Cab Service Near Me, Pune Premium Cab for Corporate, Pune Premium Taxi Service Online"
  />
  <script type="application/ld+json">
    {JSON.stringify(premiumCabSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/56.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Premiumcabserviceinpune;